export default __webpack_public_path__ + "static/whitehead-97ab31126132e08f87505df4ff66261d.png";